import { isEmpty } from 'lodash';

const checkFilterInformation = (data) => {
    const { brand, product, agg, dcName } = data;

    return !isEmpty(brand) || !isEmpty(product) || !isEmpty(agg) || !isEmpty(dcName);
};

export default checkFilterInformation;
